import { IPartCategory } from "./Part";
import { DefaultResponseWithData } from "./system";

export interface IPartLookupResponse extends DefaultResponseWithData<IPartDataResponse> { }

export const PartProBlackList: string[] = ["chrysler", "daeweoo", "daihatsu", "dodge", "isuzu", "jeep", "lancia", "mitsubishi", "opel", "ssangyong", "subaru"];

export interface IPartDataResponse {
  requestId: string;
  vin: string;
  requestedParts: IPartResponse[];
  failedUcids: string[];
  make: string;
  model: string;
  manufacturerPaintColourCode: string;
  vehicleEquipment: IVehicleEquipment[];
}

export interface IVehicleEquipment {
  family: string;
  manufacturerCodes: string;
  source: string;
  subFamily: string;
  value: string;
  description: string;
  familyDescription: string;
  subFamilyDescription: string;
}

export interface IPartResponse {
  partType: string;
  partNumber: string;
  ucid: string;
  partCategory: IPartCategory;
  priceInformation: IPartPriceStatistics;
}

export interface IPartPriceStatistics {
  partNumber: string;
  minPrice: number;
  maxPrice: number;
  avgPrice: number;
  manufacturerPrice: number;
  confidence: string;
}


export interface IMarketDataLookupRequest {
  make: string | undefined;
  model: string | undefined;
  year: number | null | undefined;
}

export interface IMarketDataLookupResponse {
  categories: ICategoryStats[];
  totalValue: number;
}

export interface ICategoryStats {
  categoryId: string;
  categoryName: string;
  minPrice: number;
  maxPrice: number;
  avgPrice: number;
  quantity: number;
}

export interface IIntelligencePricingResponse extends DefaultResponseWithData<ISerpApiSearchResult[]> { }

export interface IBulkIntelligencePricingResult {
  partId: string;
  results: ISerpApiSearchResult[];
}

export interface IBulkIntelligencePricingResponse extends DefaultResponseWithData<IBulkIntelligencePricingResult[]> { }

export interface ISerpApiSearchResult {
  searchTerm: string;
  title: string;
  link: string;
  condition: string;
  priceRaw: string;
  priceExtracted: number | null;
  thumbnail: string;
  isSold: boolean;
  soldDate: string | null;
}